import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import TripPlanner from '../views/TripPlanner.vue'
import RoutesAll from '../views/RoutesAll.vue'
import RoutesNearby from '../views/RoutesNearby.vue'
// import RouteDetails from '../views/RouteDetails.vue'
import NotFound from '../views/NotFound.vue'
import store from '../store'


Vue.use(Router)

// define the routes (English)
const routesEN = [
  {
    name: 'home',
    path: '/',
    component: Home
  },
  {
    name: 'routes-nearby',
    path: '/nearby/:lat?/:lng?',
    alias: ['/routes-nearby/:lat?/:lng?'],
    component: RoutesNearby
  },
  {
    name: 'routes-all',
    path: '/routes/:routeNo?',
    alias: ['/routes-all/:routeNo?'],
    component: RoutesAll
  },
  {
    name: 'trip-planner-inputs-empty',
    path: '/plan/',
    alias: ['/plan-trip', '/trip-planner', '/trip-options'],
    component: TripPlanner
  },
  {
    name: 'trip-planner-geocode-dest',
    path: '/plan/:finishName2Geocode',
    alias: [
      '/plan-trip/:finishName2Geocode',
      '/trip-planner/:finishName2Geocode',
      '/trip-options/:finishName2Geocode'],
    component: TripPlanner
  },  
  {
    name: 'trip-planner-inputs-start-ready',
    path: '/plan/:startName/:startLat/:startLng',
    alias: [
      '/plan-trip/:startName/:startLat/:startLng',
      '/trip-planner/:startName/:startLat/:startLng',
      '/trip-options/:startName/:startLat/:startLng'],
    component: TripPlanner
  },
  {
    name: 'trip-planner-inputs-finish-ready',
    path: '/plan/finish/:finishName/:finishLat/:finishLng',
    alias: [
      '/plan-trip/finish/:finishName/:finishLat/:finishLng',
      '/trip-planner/finish/:finishName/:finishLat/:finishLng',
      '/trip-options/finish/:finishName/:finishLat/:finishLng'],
    component: TripPlanner
  },
  {
    name: 'trip-planner-inputs-ready',
    path: '/plan/:startName/:startLat/:startLng/:finishName/:finishLat/:finishLng/:date/:time/:deparr',
    alias: [
      '/plan-trip/:startName/:startLat/:startLng/:finishName/:finishLat/:finishLng/:date/:time/:deparr',
      '/trip-planner/:startName/:startLat/:startLng/:finishName/:finishLat/:finishLng/:date/:time/:deparr',
      '/trip-options/:startName/:startLat/:startLng/:finishName/:finishLat/:finishLng/:date/:time/:deparr'],
    component: TripPlanner
  },
  {
    name: 'trip-planner-inputs-ready-plan',
    path: '/plan/:startName/:startLat/:startLng/:finishName/:finishLat/:finishLng/:date/:time/:deparr/plan',
    alias: [
      '/plan-trip/:startName/:startLat/:startLng/:finishName/:finishLat/:finishLng/:date/:time/:deparr/plan',
      '/trip-planner/:startName/:startLat/:startLng/:finishName/:finishLat/:finishLng/:date/:time/:deparr/plan',
      '/trip-options/:startName/:startLat/:startLng/:finishName/:finishLat/:finishLng/:date/:time/:deparr/plan'],
    component: TripPlanner
  },
  {
    name: 'trip-planner-trip-details',
    path: '/plan/:startName/:startLat/:startLng/:finishName/:finishLat/:finishLng/:date/:time/:deparr/trips/:tripIndex',
    alias: [
      '/plan-trip/:startName/:startLat/:startLng/:finishName/:finishLat/:finishLng/:date/:time/:deparr/trips/:tripIndex',
      '/trip-planner/:startName/:startLat/:startLng/:finishName/:finishLat/:finishLng/:date/:time/:deparr/trips/:tripIndex',
      '/trip-options/:startName/:startLat/:startLng/:finishName/:finishLat/:finishLng/:date/:time/:deparr/trips/:tripIndex'],
    component: TripPlanner
  },
  {
    name: 'any',
    path: '*',
    component: NotFound
  }
]

// define the spanish equivalent routes
const routesES = routesEN
  .filter(x => x.name !== 'any')
  .map(x => {
    let result = {}
    result.name = 'es-' + x.name
    result.path = '/es' + x.path
                    .split("nearby").join("cercano")
                    .split("routes").join("rutas")
                    .split("plan").join("planear")
    result.alias = x.alias
    result.component = x.component
    return result;
  })

// combine both english and spanish
const routes = [...routesEN, ...routesES];
// console.log('routes', routes);


// import routes for app
const router = new Router({
  mode: 'history',
  routes
})

// state is effected by current route url, thus mutate state accordingly
router.beforeEach((to, from, next) => {
  // console.log("router.beforeEach", "to: " + to.name, "from: " + from.name, "pathname: " + window.location.pathname, router)

  // UrlDecode all params and querystrings using decodeURI! Remeber this does not  decode +,' or = symbols
  Object.keys(to.params).map(key => {
    to.params[key] = decodeURI((to.params[key] + '').replace(/\+/g, '%20'))
  })
  Object.keys(to.query).map(key => {
    to.query[key] = decodeURI((to.query[key] + '').replace(/\+/g, '%20'))
  })

  // update store with url path parameters addPathParams2Store(to.params)
  if (to.params.startName && to.params.startLat && to.params.startLng) {
    store.commit('tripPlanner/SET_INPUT_ORIGIN', {
      name: to.params.startName, lat: parseFloat(to.params.startLat), lng: parseFloat(to.params.startLng)
    })
  }
  if (to.params.finishName && to.params.finishLat && to.params.finishLng) {
    store.commit('tripPlanner/SET_INPUT_DESTINATION', {
      name: to.params.finishName, lat: parseFloat(to.params.finishLat), lng: parseFloat(to.params.finishLng)
    })
  }
  if (to.params.date) {
    store.commit('tripPlanner/SET_INPUT_DATE', to.params.date)
  }
  if (to.params.time) {
    store.commit('tripPlanner/SET_INPUT_TIME', to.params.time)
  }
  if (to.params.deparr) {
    store.commit('tripPlanner/SET_INPUT_DEPART_ARRIVE', to.params.deparr)
  }
  if (to.params.tripIndex) {
    store.commit('tripPlanner/SET_SELECTED_TRIP_INDEX', to.params.tripIndex)
  }

  // update store with url query parameters addQueryParams2Store(to.params)
  let tripOptions = Object.assign({}, store.getters['tripPlanner/inputs'].options)
  Object.keys(to.query).map(key => {
    tripOptions[key] = to.query[key]
  })
  store.commit('tripPlanner/SET_TRIP_OPTIONS', tripOptions)

  // reset trip data
  if (to.name.includes('trip-planner-inputs-empty')) {
    store.commit('tripPlanner/RESET')
  }

  // plan trip
  if (to.name.includes('trip-planner-inputs-ready-plan') || (to.name.includes('trip-planner-trip') && from.name === null)) {
    store.dispatch('tripPlanner/getTripsOTP', false) // get future trips
      .then(x => {
        if (to.query.compareFutureCurrent) {
          store.dispatch('tripPlanner/getTripsOTP', true) // get current trips
        }
      })
  }

  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js